import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { OPERATOR_PROFILE_KEY } from '../operator/useGetProfile'

type UpdateActiveStatusPayload = {
  userId: string
  isActive: boolean
}

export function useUpdateActiveStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ userId, isActive }: UpdateActiveStatusPayload) => {
      await apiClient.patch(`/int/v3/users/${userId}/active-status`, { isActive })
    },
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries({ queryKey: [OPERATOR_PROFILE_KEY, userId] })
    },
  })
}
